import React, { FC } from 'react'
import DATA from 'data/artistArticles/data.json'
import styles from './artistProfile.module.scss'
import GridLayout from 'components/SA/GridPosts/GridPosts'
import { useSelector } from 'react-redux'
import { getAccountUserID } from '../selectors'
const FeaturedArticles: FC = () => {
  const accountUserID = useSelector(getAccountUserID)
  const filteredData = DATA.filter((item) => Number(item.artistId) === accountUserID)
  const artistArticles = filteredData.length ? filteredData[0].articles : []
  if (!filteredData.length) {
    return null
  }

  const transFormedData = artistArticles.map((article) => {
    const { description, title, articleLink, imageUrl } = article

    return {
      image: imageUrl,
      title: title,
      linkUrl: articleLink,
      description: description,
      linkTitle: 'Read More',
    }
  })

  return (
    <div className={styles.featuredArticles}>
      <GridLayout data={transFormedData} title='Features And Editorial' />
    </div>
  )
}

export default FeaturedArticles
